import { api } from "../../lib/api";
export const getProjectGeofence = async (projectId, partyNumber) => {
    const params = {};
    if (partyNumber) {
        params.partyNumber = partyNumber;
    }
    const queryParams = Object.keys(params).length ? `?${new URLSearchParams(params).toString()}` : "";
    const { data } = await api.get(`/projects/${projectId}/geofences${queryParams}`);
    return data;
};
export const createProjectGeofence = async (projectId, partyNumber, requestBody) => {
    const config = {
        params: {
            partyNumber
        }
    };
    const queryParams = new URLSearchParams(config.params).toString();
    const { data } = await api.post(`/projects/${projectId}/geofences${queryParams && "?" + queryParams}`, requestBody);
    return data;
};
export const deleteProjectGeofence = async (projectId, geofenceId, partyNumber) => {
    const config = {
        params: {
            partyNumber
        }
    };
    const queryParams = new URLSearchParams(config.params).toString();
    const { data } = await api.delete(`/projects/${projectId}/geofences/${geofenceId}${queryParams && "?" + queryParams}`);
    return data;
};
export const updateProjectGeofence = async (projectId, geofenceId, partyNumber, requestBody) => {
    const config = {
        params: {
            partyNumber
        }
    };
    const queryParams = new URLSearchParams(config.params).toString();
    const { data } = await api.patch(`/projects/${projectId}/geofences/${geofenceId}${queryParams && "?" + queryParams}`, requestBody);
    return data;
};
